module.exports = __webpack_public_path__ + "img/logo.23227d11.png";